// The project owner's Nostr pubkey (hex). The owner is always granted Pro,
// both client-side (as a UX convenience) and — authoritatively — server-side
// in netlify/functions/entitlement.mjs. Keep these two values in sync.
export const OWNER_PUBKEY =
  'df5bcaba9e74cc1764c9773ae160299dde5acf79416e2c96758dba225e6707cc';
